module.exports = __webpack_public_path__ + "static/img/bip8.6c25ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bip8.png
// module id = W/LA
// module chunks = 73